import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { useLevelOfDetail } from '@/pinia/levelOfDetail'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'LevelOfDetailControl',
  setup(__props) {

const { t } = useI18n()
const lod = useLevelOfDetail()
const { currentLevelOfDetail } = storeToRefs(lod)

return (_ctx: any,_cache: any) => {
  return (_unref(currentLevelOfDetail) === 'SPACE')
    ? (_openBlock(), _createBlock(ButtonSquare, {
        key: 0,
        size: "small",
        class: "navigation-buttons__button",
        title: _unref(t)('mapbox__navigation__control__lod_change'),
        imgSource: require('@/assets/square.svg'),
        onClicked: _unref(lod).cycleLevelOfDetail
      }, null, 8, ["title", "imgSource", "onClicked"]))
    : (_unref(currentLevelOfDetail) === 'LEVEL')
      ? (_openBlock(), _createBlock(ButtonSquare, {
          key: 1,
          size: "small",
          class: "navigation-buttons__button",
          title: _unref(t)('mapbox__navigation__control__lod_change'),
          imgSource: require('@/assets/grid-01.svg'),
          onClicked: _unref(lod).cycleLevelOfDetail
        }, null, 8, ["title", "imgSource", "onClicked"]))
      : _createCommentVNode("", true)
}
}

})